import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const SlidersAll = () => {
  const [slideImages, setSlideImages] = useState([]);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/slides`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        console.log(response.data?.data);
        const data = response.data?.data;
        setSlideImages(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleAddNewSliders = () => {
    navigate("/add-sliders");
  };

  const handleViewAllSliders = () => {
    navigate("/all-sliders");
  };

  const handleEdit = (id) => {
    navigate(`/edit-sliders/${id}`);
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this slider?"
    );
    if (!confirmDelete) return;

    try {
      await axios.delete(`${API_BASE_URL}/admin/slides/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      setSlideImages((prevImages) =>
        prevImages.filter((image) => image._id !== id)
      );
      alert("Slider deleted successfully.");
    } catch (error) {
      console.error("Error deleting slider:", error);
      alert("Failed to delete the slider. Please try again.");
    }
  };

  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>All Sliders</h5>
          <div className="subjectdiv2">
            <button className="handleNewSubject" onClick={handleAddNewSliders}>
              + Add New Slider
            </button>
            <button className="allSubjects" onClick={handleViewAllSliders}>
              All Sliders
            </button>
          </div>
        </div>

        <div className="classes-table-container">
          <h5>All Sliders</h5>
          <table className="classes-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Slider Image</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {/* Sample data rows */}

              {slideImages.map((data, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  {/* <td>{schoolClassName}</td> */}
                  <td>
                    <img
                      src={`${API_BASE_URL}/uploads/${data.slideImage}`}
                      alt=""
                      className="w-25"
                    />
                  </td>
                  {/* <td>7</td> */}
                  <td className="table-action-icons d-flex">
                    <i
                      className="fa-solid fa-file-pen"
                      onClick={() => handleEdit(data._id)}
                    ></i>
                    &nbsp;&nbsp;
                    <i
                      className="fa-solid fa-trash-can"
                      onClick={() => handleDelete(data._id)}
                    ></i>
                  </td>
                </tr>
              ))}

              {/* Add more rows as needed */}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SlidersAll;
